import React from 'react';
import {
  Container, Paper, Box, Button,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function NotFoundDataPage() {
  const navigate = useNavigate();
  return (
    <Container>
      <Paper variant="outlined" style={{ padding: '20px', textAlign: 'center' }}>
        <Box>存在しないデータです。</Box>
        <Box mt={1}>削除されたか、URLが間違っている可能性があります。</Box>
        <Box mt={2}>
          <Button onClick={() => navigate('/')}>HOMEに戻る</Button>
        </Box>
      </Paper>
    </Container>
  );
}
